import { GET_NOTIFICATION_STATS } from '@/graphql/notifications'
import apolloClient from '@/services/apollo-client'

const state = {
  unreadCount: 0,
  totalCount: 0,
  readCount: 0,
  loading: false,
  error: null,
}

const mutations = {
  SET_NOTIFICATION_STATS(state, stats) {
    console.log('🔄 SET_NOTIFICATION_STATS mutation called with:', stats);
    console.log('📊 Previous state:', { total: state.totalCount, unread: state.unreadCount, read: state.readCount });
    state.totalCount = stats.total
    state.unreadCount = stats.unread
    state.readCount = stats.read
    console.log('📊 New state:', { total: state.totalCount, unread: state.unreadCount, read: state.readCount });
    // Persist to localStorage
    localStorage.setItem('notification_stats', JSON.stringify({
      total: stats.total,
      unread: stats.unread,
      read: stats.read
    }))
  },
  INCREMENT_UNREAD_COUNT(state) {
    state.unreadCount++
    state.totalCount++
    // Persist to localStorage
    localStorage.setItem('notification_stats', JSON.stringify({
      total: state.totalCount,
      unread: state.unreadCount,
      read: state.readCount
    }))
  },
  DECREMENT_UNREAD_COUNT(state) {
    console.log('📉 DECREMENT_UNREAD_COUNT mutation called');
    console.log('📊 Previous unread count:', state.unreadCount);
    if (state.unreadCount > 0) {
      state.unreadCount--
      console.log('📊 New unread count:', state.unreadCount);
    } else {
      console.log('⚠️ Cannot decrement - already at 0');
    }
    // Persist to localStorage
    localStorage.setItem('notification_stats', JSON.stringify({
      total: state.totalCount,
      unread: state.unreadCount,
      read: state.readCount
    }))
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_ERROR(state) {
    state.error = null
  },
  CLEAR_NOTIFICATION_STATS(state) {
    state.unreadCount = 0
    state.totalCount = 0
    state.readCount = 0
    // Clear from localStorage
    localStorage.removeItem('notification_stats')
  },
}

const actions = {
  // Initialize store with persisted data, then fetch fresh data
  async initializeNotificationStats({ commit, dispatch }, { forceRefresh = false } = {}) {
    console.log('🔢 Initializing notification stats...')
    
    // Load from localStorage first for immediate display (unless forcing refresh)
    if (!forceRefresh) {
      try {
        const saved = localStorage.getItem('notification_stats')
        if (saved) {
          const stats = JSON.parse(saved)
          console.log('📱 Loaded cached stats:', stats)
          commit('SET_NOTIFICATION_STATS', stats)
        } else {
          console.log('📱 No cached stats found')
        }
      } catch (error) {
        console.error('Error loading persisted notification stats:', error)
      }
    } else {
      console.log('🔄 Force refresh requested, skipping cache')
    }
    
    // Then fetch fresh data from database
    console.log('🌐 Fetching fresh stats from database...')
    await dispatch('fetchNotificationStats')
  },

  async fetchNotificationStats({ commit }) {
    commit('SET_LOADING', true)
    commit('CLEAR_ERROR')
    
    try {
      const response = await apolloClient.query({
        query: GET_NOTIFICATION_STATS,
        fetchPolicy: 'network-only',
      })
      
      const stats = response.data.notificationStats
      console.log('✅ Fresh stats from database:', stats)
      commit('SET_NOTIFICATION_STATS', stats)
    } catch (error) {
      console.error('Error fetching notification stats:', error)
      commit('SET_ERROR', error.message)
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  incrementUnreadCount({ commit }) {
    commit('INCREMENT_UNREAD_COUNT')
  },
  
  decrementUnreadCount({ commit }) {
    console.log('📉 decrementUnreadCount action called');
    commit('DECREMENT_UNREAD_COUNT')
  },
  
  updateStats({ commit }, stats) {
    commit('SET_NOTIFICATION_STATS', stats)
  },
  
  clearNotificationStats({ commit }) {
    commit('CLEAR_NOTIFICATION_STATS')
  },
}

const getters = {
  hasUnreadNotifications: (state) => state.unreadCount > 0,
  unreadCount: (state) => state.unreadCount,
  totalCount: (state) => state.totalCount,
  readCount: (state) => state.readCount,
  isLoading: (state) => state.loading,
  error: (state) => state.error,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} 